<template>
  <div class="modal light" :class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t('modals.changePassword.title') }}</p>
        <button class="delete" aria-label="close" @click="closeModal"></button>
      </header>
      <section class="modal-card-body">
        <form @submit.prevent="handleSubmit">
          <div class="field">
            <label for="" class="label">{{
              $t('modals.changePassword.oldPasswordLabel')
            }}</label>
            <div class="control has-icons-left">
              <input
                v-model="oldPassword"
                type="password"
                placeholder="e.g. bobsmith@gmail.com"
                class="input text-center"
                required
              />
              <span class="icon is-small is-left">
                <i class="fas fa-lock"></i>
              </span>
            </div>
          </div>
          <div class="field">
            <label for="" class="label">{{
              $t('modals.changePassword.newPasswordLabel')
            }}</label>
            <div class="control has-icons-left">
              <input
                v-model="newPassword"
                type="password"
                placeholder="e.g. bobsmith@gmail.com"
                class="input text-center"
                required
              />
              <span class="icon is-small is-left">
                <i class="fas fa-lock"></i>
              </span>
            </div>
          </div>
          <div class="field">
            <label for="" class="label">{{
              $t('modals.changePassword.newConfirmPasswordLabel')
            }}</label>
            <div class="control has-icons-left">
              <input
                v-model="newConfirmPassword"
                type="password"
                placeholder="e.g. bobsmith@gmail.com"
                class="input text-center"
                required
              />
              <span class="icon is-small is-left">
                <i class="fas fa-lock"></i>
              </span>
            </div>
          </div>
          <div class="error field has-text-centered has-text-danger">
            {{ error }}
          </div>
          <div class="box-button m-t-30">
            <button
              type="button"
              class="button full-50 is-light"
              @click="closeModal"
            >
              {{ $t('modals.cancelBtn') }}
            </button>

            <button type="submit" class="button full-50 is-primary">
              {{ $t('modals.saveBtn') }}
            </button>
          </div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import apiAccount from '@/api/account'
import i18n from '@/language'
export default {
  name: 'ModalEditProfile',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    profile: {
      type: Object
    }
  },
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      newConfirmPassword: '',
      error: null
    }
  },
  methods: {
    handleSubmit() {
      if (!this.oldPassword) return false
      if (!this.newPassword) return false
      if (!this.newConfirmPassword) return false

      if (this.newPassword !== this.newConfirmPassword) {
        this.error = i18n.t('modals.changePassword.passwordNotEqualMsg')
        return
      }

      let loading = this.$loading.show()

      setTimeout(async () => {
        try {
          const data = await apiAccount.changePassword(
            this.oldPassword,
            this.newPassword
          )
          if (data) {
            this.closeModal()
            this.showSuccessAlert()
          }
        } catch (error) {
          this.showErrorAlert(error)
        } finally {
          loading.hide()
        }
      }, 200)
    },
    closeModal() {
      this.$emit('closeModal', null)

      this.oldPassword = ''
      this.newPassword = ''
      this.newConfirmPassword = ''
      this.error = null
    },
    showSuccessAlert() {
      this.$swal(
        i18n.t('modals.successMsg'),
        i18n.t('modals.savedMsg'),
        'success'
      )
    },
    showErrorAlert(text) {
      this.$swal(i18n.t('modals.errorMsg'), text, 'error')
    }
  }
}
</script>

<style scoped lang="scss"></style>
